import { React, useApi, useState, useParams, Grid2, SelectChangeEvent, useEffect, useNavigate, formatNumberWithCommas, Box, Paper, Typography } from '../../../utils/globalImports';
import { CustomDropdown, CustomButton, SearchBar, ProposalFrameworkModal, ProposalAddFeeStageModal, ProposalAddCustomFeeStageModal, validationMessages, CustomDataTable, Toaster } from '../../../utils/globalImports';
import { ApiResponse } from '../../../services/apiService';
import { FilterListOutlined } from '@mui/icons-material';
export type DialogAction = "toggle" | "delete";
interface ProposalFeeStage {
    id: number;
    feeStageNumber: string;
    type: number;
    proposalId: number;
    projectId: number;
    frameworkId: number;
    feeStageId: number;
    refrenceNumber: string;
    description: string;
    unitPrice: number;
    unitPricePer: string;
    status: number;
    completionNotes: number;
    createdId: number;
    quantity: number;
    proposalValue: number;
    instructedValue: number;
    unInstructedValue: number;
    instructedQuantity?: number;
    subCategoryName?: string;
}

interface ProposalFramework {
    proposalId?: number;
    projectId: number;
    clientId: number;
    frameworkId: number;
    frameworkName: string;
    isDefault: number;
}

interface Props {
    proposalFramework?: ProposalFramework[];
    disabled?: boolean;
}

const ProposalFeeStage: React.FC<Props> = ({ proposalFramework, disabled }) => {

    const { execute } = useApi();
    const navigate = useNavigate();
    const [status, setStatus] = useState<number>(1);
    const [query, setQuery] = useState("");

    const [showFrameworkModal, setShowFrameworkModal] = useState(false);
    const [showFeeStageModal, setShowFeeStageModal] = useState(false);
    const [showCustomFeeStageModal, setCustomShowFeeStageModal] = useState(false);
    const [selectedFrameworkId, setSelectedFrameworkId] = useState<number>();
    const [frameworks, setFrameworks] = useState<any[]>([]);
    const [selectedFeeStage, setSelectedFeeStage] = useState<any | null>(null);
    const [customDeleteMessage, setCustomDeleteMessage] = useState("");

    const [feeStageData, setFeeStageData] = useState<any[]>([]);
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const [dialogOpen, setDialogOpen] = useState(false); // State to manage confirm dialog "open/close" state
    const [isOn, setIsOn] = useState<boolean>();  // State to manage the toggle button's "on/off" state
    const [toast, setToast] = useState({ open: false, message: "", type: "success" });

    const { proposalId } = useParams<{ proposalId?: string }>(); // Get proposalId from URL
    const { projectId } = useParams<{ projectId?: string }>(); // Get projectId from URL

    const userId = Number(localStorage.getItem("userId"));

    const [dialogAction, setDialogAction] = useState<DialogAction>();

    useEffect(() => {
        fetchFeeStages()
    }, [])


    const sortOptions = [
        { value: "feeStageNumber", text: "Fee Stage" },
        { value: "Description", text: "Description" },
        { value: "Sub-Category", text: "Sub-Category" },
    ];


    const handleSubmitFramework = () => {
        setShowFrameworkModal(false);
        setShowFeeStageModal(true);
    }

    // filter Data
    const handleSearchClick = () => {
        const lowerCaseQuery = query.toLowerCase();

        // Map status strings to corresponding numbers
        const statusMapping: Record<string, number> = {
            Active: 1,
            Inactive: 0,
        };

        const filtered = feeStageData.filter((item) => {

            // Convert item.Status to its numeric equivalent or skip if it doesn't match
            const itemStatus = statusMapping[item.Status] ?? -1;

            const matchesQuery =
                item["Fee Stage"].toLowerCase().includes(lowerCaseQuery) ||
                item["Description"].toLowerCase().includes(lowerCaseQuery) ||
                (item["Sub-Category"]?.toLowerCase().includes(lowerCaseQuery) ?? false);

            const matchesStatus =
                status === -1 || status === 2 || itemStatus === status;

            return matchesQuery && matchesStatus;
        })
            .sort((a, b) =>
                a["Fee Stage"].localeCompare(b["Fee Stage"], undefined, { sensitivity: 'base' }) ||
                a["Description"].localeCompare(b["Description"], undefined, { sensitivity: 'base' }) ||
                (a["Sub-Category"] ?? "").localeCompare(b["Sub-Category"] ?? "", undefined, { sensitivity: 'base' })
            );
        setFilteredData(filtered);
    }


    // fetch fetchFrameworks
    const fetchFrameworks = async () => {
        //  const { data } = await execute('get', `/Proposal/frameworks/${proposalId}`);
        if (proposalFramework) {
            setFrameworks(proposalFramework)
            setSelectedFrameworkId(proposalFramework[0].frameworkId);
            proposalFramework.length > 1 ? setShowFrameworkModal(true) : setShowFeeStageModal(true)
        }
    };

    // fetch feeStages
    const fetchFeeStages = async () => {
        const { data } = await execute<ProposalFeeStage[]>('get', `/Proposal/feeStages/${proposalId}/${projectId}`);
        if (data) {
            // Use reduce to exclude unwanted fields
            const feeStageData = data
                .map((proposal) => {
                    const { id, feeStageNumber, proposalId, subCategoryName, projectId, feeStageId, refrenceNumber, description, unitPrice, unitPricePer, completionNotes, quantity, proposalValue, instructedValue, unInstructedValue, status } = proposal;
                    const Status = status === 1 ? 'Active' : 'Inactive';
                    const price = `${unitPrice.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' })} ${unitPricePer}`;

                    return {
                        id,
                        proposalId,
                        "Fee Stage": feeStageNumber,
                        "Sub-Category": subCategoryName,
                        // projectId,
                        "Description": description,
                        "Unit Price": price,
                        "Quantity": formatNumberWithCommas(quantity),
                        "Proposal Value": proposalValue.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }),
                        "Instructed Value": instructedValue.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }),
                        "Uninstructed Value": unInstructedValue.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }),
                        "Forecast": "",
                        "WIP Accrued": "",
                        "Pre-Billed Accrued": "",
                        "Invoiced": "",
                        "Work Budget Remaining": "",
                        "Invoice Budget Remaning": "",
                        "Stage": "",
                        "Terms and Notes": completionNotes,
                        Status
                    };
                });

            setFeeStageData(feeStageData);
            //  Filter for status = 1(Active) and set to filteredData
            // const activeFeeStage = feeStageData
            //     .filter((feeStage) => feeStage.Status === 'Active')
            const filteredByStatus = feeStageData.filter((feeStage) => {
                if (status === 1) return feeStage.Status === 'Active';
                if (status === 0) return feeStage.Status === 'Inactive';
                return true;
            })
            setFilteredData(filteredByStatus);

        }
    }


    //#region handle edit and toggle state

    const handleEdit = (feeStage: any) => {
        setSelectedFeeStage(feeStage)
        setCustomShowFeeStageModal(true)
    };

    const handleRowDoubleclick = (row: any) => {
        navigate(`/proposal/feestage/edit-feestage/${row.id}/${disabled}`, {
            state: { fromTab: 7 }
        });
    }

    const handleDelete = (row: any) => {
        setDialogAction("delete");
        setSelectedFeeStage(row);
        // If proposalId exists → this fee stage is used in another project
        if (row.proposalId) {
            setCustomDeleteMessage(
                "This fee stage is used in another project. Do you still want to delete it?"
            );
        } else {
            setCustomDeleteMessage("Are you sure you want to delete this fee stage?");
        }
        setIsOn(false);

        setDialogOpen(true);
    };

    const handleToggleState = (row: any) => {
        setDialogAction("toggle");
        setCustomDeleteMessage("");
        if (row.Status === 'Inactive') {
            setIsOn(false)
        } else {
            setIsOn(true)
        }
        setSelectedFeeStage(row);
        setDialogOpen(true);
    }

    const handleDialogCancel = () => {
        setDialogOpen(false);
        setSelectedFeeStage(null); // Reset selectedUser when modal closes
        setCustomDeleteMessage("");
        setDialogAction(undefined)
    }

    const handleDialogConfirm = async () => {
        if (!selectedFeeStage) return;
        try {
            // Make API call to update the status
            const { data } = await execute<ProposalFeeStage>('get', `/Proposal/feeStages/${selectedFeeStage.id}`);
            if (data) {
                // Step 2: Update the fields on the filtered record

                // Added unitPrice, quantity and instructedQuantity to avoid displaying 0 or 0.00 during FeeStage log-in.
                // We are using the same PUT method, which updates all properties by default.
                const updatedFeeStageData = {
                    ...data, // Keep the original user data
                    status: selectedFeeStage.Status === 'Active' ? 0 : 1,
                    updatedId: userId, // You can also update any additional fields like updatedId
                    unitPrice: data.unitPrice.toFixed(2),
                    instructedQuantity: data?.instructedQuantity?.toFixed(1),
                    quantity: Number(data.quantity).toFixed(2),
                };

                let response: ApiResponse<any> = await execute('put', '/Proposal/framework/UpdatefeeStage', updatedFeeStageData);
                if (response!) {
                    if (response.error) {
                        // If there's an error in the response, display the error message
                        setToast({ open: true, message: response.error, type: "error" });
                    } else {
                        // If the response is successful, display the success message
                        setToast({ open: true, message: response.data, type: "success" });
                    }
                }
            }
            fetchFeeStages();
            setSelectedFeeStage(null); // Clear selected row
        } catch (error) {
            console.error('Error updating status:', error);
        } finally {
            setDialogOpen(false);
        }
    };

    //#endregion



    return (
        <>
            <Box>
                <Paper elevation={0} sx={{ border: '1px solid #e0eaf6', borderRadius: '14px', overflow: 'hidden' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, backgroundColor: '#f0f6ff', borderBottom: '1px solid #e0eaf6' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <FilterListOutlined sx={{ fontSize: 18, color: '#1e66ab' }} />
                            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1e66ab', fontFamily: 'Poppins' }}>
                                Filters
                            </Typography>
                        </Box>
                    </Box>
                    <Grid2 container spacing={2}
                        sx={{
                            flexWrap: "wrap",
                            gap: 1,
                            display: "flex",
                            flexDirection: "row",
                            padding: '10px 20px 10px 20px',
                            backgroundColor: '#f7faff'
                        }}   >
                        {/* Search Bar */}
                        <Grid2 size={{ xs: 12 }}>
                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.8px', fontFamily: 'Poppins', }}>
                                Search & Filter
                            </Typography>
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 12,
                                md: 6,
                                lg: 4
                            }}
                        >
                            <SearchBar
                                placeholder={validationMessages.proposal_feestage_serachText}
                                onQueryChange={setQuery}
                                sx={{ boxShadow: "0px 4px 12px 4px #d7d7d7" }} />
                        </Grid2>

                        {/* status Dropdown */}
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            <CustomDropdown
                                value={status}
                                onChange={(event: SelectChangeEvent<string | number>) => setStatus(Number(event.target.value))}
                                label="Select Status"
                                sx={{ backgroundColor: '#fff' }}
                            />
                        </Grid2>

                        {/* serach button */}
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            <CustomButton
                                capsule
                                sx={{
                                    mt: 0,
                                    mb: 2,
                                    textTransform: 'none'
                                }}
                                backgroundColor="#1e66ab"
                                hoverColor="rgba(150, 193, 33, 0.75)"
                                onClick={handleSearchClick} // Trigger search when clicked
                            >
                                Search
                            </CustomButton>
                        </Grid2>

                        {/* add fee stage from framework */}
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            <CustomButton
                                capsule
                                sx={{
                                    mt: 0,
                                    mb: 2,
                                    textTransform: 'none',
                                    whiteSpace: 'nowrap',
                                }}
                                type="button"
                                disabled={disabled}
                                onClick={() => {
                                    fetchFrameworks()
                                }} // Trigger search when clicked
                            >
                                Add Fee Stage
                            </CustomButton>
                        </Grid2>


                        {/* add custom fee stage  */}
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            <CustomButton
                                capsule
                                sx={{
                                    mt: 0,
                                    mb: 2,
                                    textTransform: 'none',
                                    whiteSpace: 'nowrap',
                                }}
                                disabled={disabled}
                                onClick={() => {
                                    setCustomShowFeeStageModal(true)
                                    setSelectedFeeStage(null)
                                }} // Trigger search when clicked

                            >
                                Add Custom Fee Stage
                            </CustomButton>
                        </Grid2>

                    </Grid2>


                </Paper>
            </Box>

            <ProposalFrameworkModal
                open={showFrameworkModal}
                onClose={() => setShowFrameworkModal(false)} frameworks={frameworks} selectedFrameworkId={Number(selectedFrameworkId)}
                onChange={(id) => {
                    setSelectedFrameworkId(id);
                }}
                onSubmit={handleSubmitFramework} >

            </ProposalFrameworkModal>

            {showFeeStageModal && (
                <ProposalAddFeeStageModal open={showFeeStageModal}
                    onClose={() => {
                        if (frameworks.length > 1) {
                            setShowFrameworkModal(true);
                            setShowFeeStageModal(false);
                        } else {
                            setShowFeeStageModal(false);
                            setShowFrameworkModal(false);
                        }
                    }}
                    frameworkId={Number(selectedFrameworkId)}
                    afterSubmit={() => {
                        setShowFrameworkModal(false)
                        setShowFeeStageModal(false)
                        fetchFeeStages()
                    }}
                >
                </ProposalAddFeeStageModal>
            )}

            <ProposalAddCustomFeeStageModal
                open={showCustomFeeStageModal}
                onClose={() => { setCustomShowFeeStageModal(false) }}
                feeStageData={selectedFeeStage}
                afterSubmit={() => {
                    setCustomShowFeeStageModal(false)
                    fetchFeeStages()
                }}
            >

            </ProposalAddCustomFeeStageModal>

            {feeStageData.length > 0
                && (
                    <CustomDataTable
                        rows={filteredData}
                        actionText="Proposal Fee Stage"
                        sortOptions={sortOptions}
                        onRowEdit={handleEdit}
                        onRowDoubleClick={handleRowDoubleclick}
                        onToggleClick={handleToggleState}
                        onRowDelete={handleDelete}
                        isDialogOpen={dialogOpen}
                        isToggleOn={isOn}
                        handleCancel={handleDialogCancel}
                        handleConfirm={handleDialogConfirm}
                        customMessage={customDeleteMessage}
                        dialogAction={dialogAction}
                        // gridHeight={'calc(100vh - 520px)'}
                        noResultMessage={validationMessages.common_RecordNotFound("feeStage")}
                        actionbuttonDisable={disabled}
                    >
                    </CustomDataTable>
                )}

            <Toaster open={toast.open} message={toast.message} type={toast.type as "success" | "error"} onClose={() => setToast({ ...toast, open: false })} />
        </>
    );
}

export default ProposalFeeStage;
